import { Component, Input } from '@angular/core';

import { ITrending } from '@shared/data-access/interfaces';

@Component({
    selector: 'pdp-tech-icons',
    templateUrl: './tech-icons.component.html',
    styleUrls: ['./tech-icons.component.scss'],
    standalone: false
})
export class TechIconsComponent {

	@Input()
	public techIconsArray: ITrending[];

	protected trackByFn(index: number, item:ITrending): string {
		return index.toString() + item.headline;
	}
}
